"use strict";
let currentY;

export function scrollLock() {
  if (document.body.classList.contains("is-scroll-locked")) {
    startScroll();
    return false;
  }

  currentY = document.documentElement.scrollTop || document.body.scrollTop;

  // メニューを開いたときにスクロール位置が一番上に戻らないように
  document.body.style.top = `-${currentY}px`;
  document.body.classList.add("is-scroll-locked");
}

function startScroll() {
  getCurrentTop(()=>{
    document.body.style.top = "";
    document.body.classList.remove("is-scroll-locked");
    window.scrollTo(0, currentY);
  });
}

function getCurrentTop(_callback) {
  currentY = Math.abs(parseFloat(document.body.style.top));
  _callback();
}
